import { useState } from "react";
import styles from "./cafeFaq.module.css";
import { Retractable } from "../../../components/retractable/retractable";
import { DeleteIcon, EditIcon } from "../../../assets/icons";

import { Text } from "../../../components/text/text";

export const FAQItem = ({ question, answer, onEdit, onDelete }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className={styles.faq_item} onClick={() => setVisible(prev => !prev)}>
            <div className={styles.faq_title}>
                <Text as="div" variant="body" className={styles.faq_question} size={14} weight={700}>
                    {question}
                </Text>
                <div className={styles.faq_controls}>
                    <EditIcon onClick={(e) => {
                        e.stopPropagation();
                        onEdit();
                    }} />
                    <DeleteIcon onClick={(e) => {
                        e.stopPropagation();
                        onDelete();
                    }} />
                </div>
            </div>
            <Retractable active={visible}>
                <Text as="div" variant="body" className={styles.faq_answer} size={16}>
                    {answer}
                </Text>
            </Retractable>
        </div>
    );
}